import Vue from 'vue'
import App from './App.vue'
import store from './store';

import './assets/styles/index.css';
import router from './router'
import wb from '@/wb';

Vue.config.productionTip = false

if (wb) {
  wb.addEventListener('waiting', () => {
    console.log('waiting...');
  });
}

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
